import { WebsiteUrlTypeEnum } from '@onArte/shared/database/enums';

export class WebsiteUrlModel {
  public id: string;
  public type: WebsiteUrlTypeEnum;
  public prettyUrl: string;
  public realUrl: string | null;
}
